function BalanceCard1({name,icon,symbol, type, currency, price, amount, amountUSD}) {
    return (
      <div className="position-relative rounded-3 p-3" style={{backgroundColor: '#ffffff0d'}}>
        <div className="position-absolute d-flex align-items-center justify-content-center rounded-2 shadow overflow-hidden" style={{height: '40px',width:'40px',top:'-20px',backgroundColor: '#ffffff18'}}>
            {icon}
        </div>
        <div className='d-flex align-items-center justify-content-between mt-1'>
            <div>
                <p className="fs-5 fw-bold mb-0">{name}</p>
                <p className="mb-0" style={{fontSize: '12px'}}>{symbol} | {type} | {currency}{price}</p>
            </div>
            <div className="text-end">
                <p className="fs-5 fw-bold mb-0"><span className="text-success">+</span> {currency}{amountUSD}</p>
                <p className="mb-0" style={{fontSize: '12px'}}>{amount} {symbol}</p>
            </div>
        </div>
      </div>
    )
  }
  
  export default BalanceCard1